<div class="content-info">
  <div class="content-title">
    <h3 class="title">Stock Write-offs</h3>
    <div class="title-actions">
      <label class="zf-search" title="Search by write-off number">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search write-off number" [(ngModel)]="searchTerm" (input)="onSearch()" />
      </label>

      <button class="btn btn-secondary text-nowrap" (click)="downloadTemplate()">
        <i class="bi bi-download"></i> Template
      </button>

      <app-excel-upload [uploadUrl]="uploadUrl" (uploadSuccess)="onUploadSuccess($event)"
        (uploadError)="onUploadError($event)"></app-excel-upload>

      <button class="btn btnprimary text-nowrap" [routerLink]="['/stock-write-off/create']">
        <i class="bi bi-plus-lg"></i> New write-off
      </button>
    </div>
  </div>

  <div class="common-table mt-2">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table">
        <thead>
          <tr>
            <th>Write-off Number</th>
            <th class="zf-num">Total Quantity</th>
            <th class="zf-num">Total Value (INR)</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="writeOffLoading">
            <td colspan="5" class="text-center">Loading write-offs…</td>
          </tr>

          <ng-container *ngIf="!writeOffLoading">
            <tr *ngFor="let writeOff of writeOffList || []">
              <td class="zf-key">
                <a [routerLink]="['/stock-write-off/create']" [queryParams]="{ view: true, id: writeOff?.id }">
                  {{ writeOff?.writeOffNumber }}
                </a>
              </td>
              <td class="zf-num">{{ writeOff?.totalQty || 0 | number }}</td>
              <td class="zf-num zf-strong">{{ writeOff?.totalValue || 0 | number : '1.2-2' }}</td>
              <td>
                <span class="zf-status" [ngClass]="{ ok: writeOff?.status === 'POSTED' }">{{ writeOff?.status }}</span>
              </td>
              <td>
                <div class="td-actions-btn">
                  <button class="btn btn-edit" [routerLink]="['/stock-write-off/create']"
                    [queryParams]="{ view: true, id: writeOff?.id }" title="View">
                    <i class="bi bi-eye"></i>
                  </button>
                  <button *ngIf="writeOff?.status === 'DRAFT'" class="btn btn-edit" [routerLink]="['/stock-write-off/create']"
                    [queryParams]="{ id: writeOff?.id }" title="Edit draft">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="(writeOffList || []).length === 0">
              <td colspan="5">
                <div class="zf-empty">
                  <strong>No stock write-offs yet</strong>
                  <span>Record damaged, expired or lost stock with a new write-off.</span>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
        </select>
        <span>entries per page</span>
      </div>

      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link">&lsaquo;</a>
        </li>
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>
        @if (currentPage > 4) {
        <li class="page-item disabled"><a class="page-link">…</a></li>
        }
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }
        @if (currentPage < pageCount - 3) {
        <li class="page-item disabled"><a class="page-link">…</a></li>
        }
        @if (pageCount > 1) {
        <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
          <a class="page-link">{{ pageCount }}</a>
        </li>
        }
        <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
          <a class="page-link">&rsaquo;</a>
        </li>
      </ul>
    </div>
  </div>
</div>
